var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOutBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6DBDBE44-8D50-4C70-882F-CF7F00315673") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.027451 0 0 0 0 0.768627 0 0 0 0 0.886275 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V6.-4-Home-/-5",
    transform: "translate(-608.000000, -374.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11-Copy",
    transform: "translate(553.000000, 319.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "basic-/-log_out",
    transform: "translate(55.000000, 55.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "basic-/-log_out-(Background/Mask)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0833333,17 L17,11.3333333 L17,15.5833333 L4.25,15.5833333 L4.25,18.4166667 L17,18.4166667 L17,22.6666667 L24.0833333,17 Z M14.1666667,4.25 C12.6040833,4.25 11.3333333,5.52074994 11.3333333,7.08333333 L11.3333333,12.75 L14.1666667,12.75 L14.1666667,7.08333333 L26.9166667,7.08333333 L26.9166667,26.9166667 L14.1666667,26.9166667 L14.1666667,21.25 L11.3333333,21.25 L11.3333333,26.9166667 C11.3333333,28.4792501 12.6040833,29.75 14.1666667,29.75 L26.9166667,29.75 C28.4792501,29.75 29.75,28.4792501 29.75,26.9166667 L29.75,7.08333333 C29.75,5.52074994 28.4792501,4.25 26.9166667,4.25 L14.1666667,4.25 Z",
    fill: "#2E3A59",
    mask: "url(#mask-3)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOutBlue);
export default __webpack_public_path__ + "static/media/logOutBlue.f7e45aab6a0e1a847fe97fa2a835d55f.svg";
export { ForwardRef as ReactComponent };